import React from "react";
import { Table } from "react-bootstrap";
import styled from "styled-components";

import {
  PromptFormula,
  hasFormulaText,
} from "components/pages/Session/Activity/activities/ConsensusActivity/PromptFormula";

const MISSING = "—";

// oko-web's global reset sets <strong> to `font-weight: inherit`, so a bold
// lead-in has to declare its own weight.
const Lead = styled.strong`
  font-weight: 700;
`;
const QUESTION_IMAGE_STYLE = { maxHeight: "160px", maxWidth: "100%", display: "block", marginTop: "8px" };

const orMissing = (text) => text ?? MISSING;

const answerText = ({ solution, answer_unit: unit }) => (unit ? `${solution} ${unit}` : solution);

const wrongAnswerText = ({ value, misconception_name: name, reasoning }) =>
  `${value} — ${name}${reasoning ? `: ${reasoning}` : ""}`;

const Misconceptions = ({ misconceptions }) => (
  <>
    <h3 className="h6">Misconceptions</h3>
    <ul aria-label="Misconceptions">
      {misconceptions.map((misconception) => (
        <li key={misconception.name}>
          <Lead>{misconception.name}</Lead>
          <div>How students think: {misconception.student_logic}</div>
          <div>Core insight: {misconception.core_insight}</div>
        </li>
      ))}
    </ul>
  </>
);

const QuestionRow = ({ question }) => (
  <tr>
    <td>{question.position}</td>
    <td>
      <div>{question.prompt}</div>
      {hasFormulaText(question.prompt_image_latex) && (
        <PromptFormula latex={question.prompt_image_latex} fallback={null} />
      )}
      {question.internal_image_url && (
        <img
          src={question.internal_image_url}
          alt={`Question ${question.position} image`}
          style={QUESTION_IMAGE_STYLE}
        />
      )}
    </td>
    <td>{answerText(question)}</td>
    <td>{orMissing(question.hint)}</td>
    <td>{orMissing(question.explanation)}</td>
    <td>
      <ul className="mb-0 ps-3">
        {question.wrong_answers.map((wrong) => (
          <li key={wrong.position}>{wrongAnswerText(wrong)}</li>
        ))}
      </ul>
    </td>
  </tr>
);

/** Everything the bank holds for one set: the data came with the list. */
export const SetDetail = ({ set }) => (
  <div>
    {set.description && <p>{set.description}</p>}
    {set.insight && (
      <div className="mb-3">
        <Lead>Set insight</Lead>
        <p className="mb-0">{set.insight}</p>
      </div>
    )}
    {set.misconceptions.length > 0 && <Misconceptions misconceptions={set.misconceptions} />}
    {set.questions.length === 0 ? (
      <p className="mb-0">This set has no questions.</p>
    ) : (
      <Table bordered size="sm" className="mb-0" aria-label="Questions">
        <thead>
          <tr>
            <th>#</th>
            <th>Question</th>
            <th>Answer</th>
            <th>Hint</th>
            <th>Explanation</th>
            <th>Wrong answers</th>
          </tr>
        </thead>
        <tbody>
          {set.questions.map((question) => (
            <QuestionRow key={question.challenge_id} question={question} />
          ))}
        </tbody>
      </Table>
    )}
  </div>
);
